import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Portal from '@material-ui/core/Portal'
import Alert from 'react-s-alert'
// CORE UI
import '../node_modules/jquery/dist/jquery'
import '../node_modules/popper.js/dist/umd/popper.min'
import '../node_modules/bootstrap/dist/js/bootstrap.min'
import '../node_modules/perfect-scrollbar/dist/perfect-scrollbar'
import '../node_modules/@coreui/coreui/dist/js/coreui.min'
import '../node_modules/@coreui/coreui/dist/css/coreui.min.css'

import './css/default.css'
import './css/veiculo.css'
import '../node_modules/material-design-icons/iconfont/material-icons.css';

import '../node_modules/react-s-alert/dist/s-alert-default.css';
import '../node_modules/react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './css/components/calendario.css';
import './css/components/nota-fiscal-cte-os.css';

import AppRoutes from './routes/AppRoutes'

import Template from './componentes/layout/Template'
import Loading from './componentes/layout/Loading'
import MessagesBar from './componentes/MessagesBar'

import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import pt from 'date-fns/locale/pt';

registerLocale('pt', pt);
setDefaultLocale('pt');

export const App = () => (
  <BrowserRouter>
    <React.Fragment>
      <Loading/>
      <Template/>
      <div className="app-body" style={{ height: '100%' }}>
        <main className="main">
          <div className="container">
            <div className="animated fadeIn">
              <AppRoutes/>
            </div>
          </div>
          <Portal>
            <MessagesBar/>
          </Portal>
        </main>
      </div>
      <Alert stack={{ limit: 2, spacing: 10 }}/>
    </React.Fragment>
  </BrowserRouter>
)

export default connect()(App)
